import * as React from 'react';
import { inject } from 'mobx-react';
import { CustomerNotifications } from 'components/common/customer-notifications';
export const SearchResultsCustomerNotificationWrapper = inject('searchResults')(({
  searchResults,
  location
}) => {
  const searchCriteria = searchResults === null || searchResults === void 0 ? void 0 : searchResults.searchCriteria;
  const {
    regionId,
    startDate,
    endDate
  } = searchCriteria || {};
  return React.createElement(CustomerNotifications, {
    location: location,
    regionId: regionId,
    startDate: startDate,
    endDate: endDate
  });
});